import type { ChartDataset } from 'chart.js';
import type { UnionToIntersection } from 'chart.js/dist/types/utils';

import { CHART_TOOLTIP_TARGET_TYPE } from '@/entities/chart/model/constants';
import type {
  CellFeedbackListModalOptions,
  CellOptionsWithName,
  ChartFeedbackListModalOptions,
} from '@/entities/chart/model/types';
import type { DashboardCardInfoT } from '@/features/Dashboard/types';

import chartUtils from './chart-utils';

export type TimeSeriesChartDataset = UnionToIntersection<
  ChartDataset<'line'>
> & {
  date_type: CHART_TOOLTIP_TARGET_TYPE;
  meta: {
    x: StringNumberValue;
    y: StringNumberValue[];
  };
};

type BuildTimeSeriesChartFeedbackListModalOptionsParams = {
  chart: ChartBase & { name: string };
  dashboardCardInfo?: DashboardCardInfoT;
  dataset: TimeSeriesChartDataset;
  dataIndex: number;
  dataLabel?: string;
  startPeakAnalysisOnFeedbackOpen?: boolean;
};

export const buildTimeSeriesChartFeedbackListModalOptions = ({
  chart,
  dashboardCardInfo,
  dataset,
  dataIndex,
  dataLabel,
  startPeakAnalysisOnFeedbackOpen,
}: BuildTimeSeriesChartFeedbackListModalOptionsParams): ChartFeedbackListModalOptions<CellFeedbackListModalOptions> => {
  const dateLabel = String(dataset.meta.y[dataIndex]);
  const unit = chartUtils.getFrequencyByTermUnit(chart.target.term.unit);
  const { start, end } = chartUtils.parseDateFormatByFrequency(dateLabel, unit);

  const cellOptions: CellOptionsWithName = {
    compared_target: dataset.date_type === CHART_TOOLTIP_TARGET_TYPE.COMPARE,
    series_index: 0,
    item_x: dataset.meta.x,
    item_x_name: dataset.label || '',
    item_y: start,
    item_y_name: dataLabel ?? dateLabel,
  };

  return {
    chart,
    dashboardCardInfo,
    isAll: false,
    cell: cellOptions,
    startPeakAnalysisOnFeedbackOpen,
    peakAnalysisDateRangeOverride: {
      startDate: start,
      endDate: end,
    },
  };
};
